export const slideStyles = `
    @keyframes scan {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
    @keyframes float {
      0%, 100% { transform: translateY(0px) rotate(0deg); }
      50% { transform: translateY(-20px) rotate(5deg); }
    }
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(30px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes fadeInLeft {
      from { opacity: 0; transform: translateX(-30px); }
      to { opacity: 1; transform: translateX(0); }
    }
    @keyframes fadeInRight {
      from { opacity: 0; transform: translateX(30px); }
      to { opacity: 1; transform: translateX(0); }
    }
    @keyframes fadeInScale {
      from { opacity: 0; transform: scale(0.9); }
      to { opacity: 1; transform: scale(1); }
    }
    @keyframes zoomInVideo {
      from { opacity: 0; transform: scale(0.5); }
      to { opacity: 1; transform: scale(1); }
    }
    @keyframes shimmer {
      0% { background-position: -1000px 0; }
      100% { background-position: 1000px 0; }
    }
    @keyframes pulse-glow {
      0%, 100% { box-shadow: 0 0 20px rgba(34, 211, 238, 0.3); }
      50% { box-shadow: 0 0 40px rgba(34, 211, 238, 0.6); }
    }
    @keyframes orbit {
      from { transform: rotate(0deg) translateX(100px) rotate(0deg); }
      to { transform: rotate(360deg) translateX(100px) rotate(-360deg); }
    }
    @keyframes blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0; }
    }
    @keyframes slideInFromLeft {
      from { opacity: 0; transform: translateX(-20px); }
      to { opacity: 1; transform: translateX(0); }
    }
    @keyframes drawLine {
      from { width: 0; }
      to { width: 100%; }
    }
    /* LE NUAGE DE MOTS de la slide « Vos réponses ». Les mots ne se contentent
       pas d'apparaître : ils se CONDENSENT — partis flous et trop grands, ils
       se resserrent jusqu'à devenir nets. C'est l'image de ce qui se passe à
       l'écran, une salle qui se cristallise en quelques mots, et ça donne à
       la cascade le poids qui manquait à un simple fondu.
       ⚠️ Le flou est coûteux à animer : il ne dure que 0,7 s et ne porte que
       sur une quarantaine de mots, jamais sur toute la slide.
       ⚠️⚠️ LE translate(-50%, -50%) EST DANS CHAQUE ÉTAPE, ET IL DOIT Y ÊTRE.
       Les mots sont posés en absolu par leur CENTRE (voir SalleSlide) ; une
       animation écrase le transform inline, donc sans ce translate dans les
       keyframes, chaque mot retombe sur son coin supérieur gauche à la fin de
       l'animation. Le nuage entier glisse alors vers le bas à droite et les
       mots se chevauchent — le placement, lui, était juste. */
    @keyframes motCondense {
      from { opacity: 0; filter: blur(14px); transform: translate(-50%, -50%) scale(1.5); }
      60%  { opacity: 1; }
      to   { opacity: 1; filter: blur(0); transform: translate(-50%, -50%) scale(1); }
    }
    /* La respiration du mot dominant : très lente, très faible. Vue de loin,
       elle attire l'œil sans qu'on sache pourquoi ; vue de près, elle ne
       bouge presque pas. */
    @keyframes motRespire {
      0%, 100% { transform: translate(-50%, -50%) scale(1); filter: drop-shadow(0 0 18px rgba(34, 211, 238, 0.35)); }
      50%      { transform: translate(-50%, -50%) scale(1.035); filter: drop-shadow(0 0 34px rgba(34, 211, 238, 0.6)); }
    }
    .animate-mot { animation: motCondense 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }
    /* ⚠️ LA VEDETTE REDÉCLARE LES DEUX ANIMATIONS, et ce n'est pas une
       redondance : animation est une propriété unique, donc cette règle —
       déclarée après — écrasait celle de .animate-mot. Le mot le plus donné
       de la salle gardait alors son opacity à 0 sans jamais recevoir
       l'animation qui la remonte : il était purement et simplement invisible,
       et c'est le seul mot que personne ne devait rater.
       ⚠️ Ce fichier est un template literal : PAS DE BACKTICK dans les
       commentaires, ils referment la chaîne et cassent le build. */
    .animate-mot-vedette {
      animation: motCondense 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards,
                 motRespire 6s ease-in-out infinite;
    }
    .animate-scan { animation: scan 3s ease-in-out infinite; }
    .animate-fade-in-up { animation: fadeInUp 0.8s ease-out forwards; }
    .animate-fade-in-left { animation: fadeInLeft 0.6s ease-out forwards; }
    .animate-fade-in-right { animation: fadeInRight 0.6s ease-out forwards; }
    .animate-fade-in-scale { animation: fadeInScale 0.6s ease-out forwards; }
    .animate-zoom-in-video { animation: zoomInVideo 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .animate-shimmer {
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
      background-size: 1000px 100%;
      animation: shimmer 3s infinite;
    }
    .animate-pulse-glow { animation: pulse-glow 2s ease-in-out infinite; }
    .animate-slide-in { animation: slideInFromLeft 0.4s ease-out forwards; }
    .animate-draw-line { animation: drawLine 0.8s ease-out forwards; }
    .typing-cursor {
      display: inline-block;
      width: 2px;
      height: 1.2em;
      background-color: #22d3ee;
      margin-left: 2px;
      animation: blink 1s step-end infinite;
    }
    .stagger-1 { animation-delay: 0.1s; opacity: 0; }
    .stagger-2 { animation-delay: 0.2s; opacity: 0; }
    .stagger-3 { animation-delay: 0.3s; opacity: 0; }
    .stagger-4 { animation-delay: 0.4s; opacity: 0; }

    @keyframes glitch {
      0% { transform: translate(0); clip-path: inset(0); filter: hue-rotate(0deg); }
      20% { transform: translate(-5px, 5px); clip-path: inset(10% 0 30% 0); filter: hue-rotate(90deg); }
      40% { transform: translate(5px, -5px); clip-path: inset(40% 0 10% 0); filter: hue-rotate(180deg); }
      60% { transform: translate(-10px, 0); clip-path: inset(20% 0 50% 0); filter: hue-rotate(270deg); }
      80% { transform: translate(10px, 5px); clip-path: inset(60% 0 5% 0); filter: hue-rotate(360deg); }
      100% { transform: translate(0); clip-path: inset(0); filter: hue-rotate(0deg); }
    }
    .animate-glitch {
      animation: glitch 0.2s linear infinite;
      background: rgba(255, 0, 0, 0.1);
      mix-blend-mode: hard-light;
    }

    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
      20%, 40%, 60%, 80% { transform: translateX(5px); }
    }
    @keyframes pulse-slow {
      0%, 100% { background-color: rgb(127, 29, 29); }
      50% { background-color: rgb(185, 28, 28); }
    }
    .animate-pulse-slow { animation: pulse-slow 1s ease-in-out infinite; }
    @keyframes scan-line {
      0% { transform: translateY(-100%); }
      100% { transform: translateY(100vh); }
    }
`;
